import React from "react";

export const BoardSection = ({ section, children }) => (
  <section
    id={section.id}
    className={`board-section board-section--${section.id}`}
    aria-labelledby={`${section.id}-title`}
    style={{ left: section.left, top: section.top }}
  >
    <header className="board-section-label">
      <span className="board-section-number">{section.number}</span>
      <span className="board-section-text">
        <span className="board-section-kicker">{section.kicker}</span>
        <h2 id={`${section.id}-title`} className="board-section-title">
          {section.title}
        </h2>
      </span>
    </header>
    {children}
  </section>
);

export default BoardSection;
